import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import ImageOption from "../../common-filters-components/ImageOption";
import OptionsCarousel from "../../common-filters-components/OptionsCarousel";
import { findChildernImages } from "./findChildernImages";
import { IProductChildMinimizedData } from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";

interface Props {
  filter: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  isFilterDrawer?: boolean;
  productChildren: IProductChildMinimizedData[];
  sliderMaxWidth?: number;
  outOfStockKeys?: string[];
  isProductBox?: boolean;
  allow_user_request_stock_availability_reminder?: boolean;
}
const SelectImages: React.FC<Props> = ({
  filter,
  state,
  setState,
  unAvailabeKeys = [],
  isFilterDrawer = false,
  productChildren,
  sliderMaxWidth,
  outOfStockKeys,
  isProductBox,
  allow_user_request_stock_availability_reminder,
}) => {
  const filterData = filter?.data;
  const is_multi_select = filter?.configurations?.is_multi_select;
  const options = findChildernImages(productChildren, filterData!) ?? [];

  return (
    <OptionsCarousel
      sliderMaxWidth={sliderMaxWidth}
      spacing={isProductBox ? 6 : 8}
      width={isProductBox ? 20 : 180}
      isFilterDrawer={isFilterDrawer}
      className="options-carousel"
    >
      {options
        ?.filter((op) => !isSelected(unAvailabeKeys, op.key))
        ?.map((option) => {
          const disabled = allow_user_request_stock_availability_reminder
            ? isSelected(unAvailabeKeys, option.key)
            : isSelected(unAvailabeKeys, option.key) ||
              isSelected(outOfStockKeys, option.key);
          const outOfStock = allow_user_request_stock_availability_reminder
            ? isSelected(outOfStockKeys, option.key)
            : undefined;
          return (
            <ImageOption
              is_multi_select={is_multi_select}
              key={option.key}
              label={option.value}
              image_src={option.image_url!}
              disabled={disabled}
              selected={isSelected(state, option.key)}
              toggleOption={() => {
                setState(toggleOption(state, option.key, is_multi_select));
              }}
              isProductBox={isProductBox}
              outOfStock={outOfStock}
            />
          );
        })}
    </OptionsCarousel>
  );
};
export default SelectImages;
